<section class="hero">
  <div>
    <p class="eyebrow">Intelligence</p>
    <h1>Risk signals</h1>
  </div>
</section>

@if (!loading() && !error()) {
  <section class="signals-grid">
    <article class="panel">
      <div class="panel-head">
        <div>
          <p class="panel-kicker">Repositories</p>
          <h2>Repository risk indicators</h2>
        </div>
        @if (repositorySignals().length) {
          <span class="count-badge">{{ repositorySignals().length }}</span>
        }
      </div>

      @if (repositorySignals().length) {
        <div class="signal-list">
          @for (signal of repositorySignals(); track signal.repositoryId) {
            <div class="signal-card" [class]="riskClass(signal.riskLevel)">
              <div class="signal-card-header">
                <div class="signal-identity">
                  <strong>{{ signal.repositoryName }}</strong>
                  <span class="signal-sub">{{ signal.projectName }}</span>
                </div>
                <span class="risk-badge" [class]="riskClass(signal.riskLevel)">{{ signal.riskLevel }}</span>
              </div>
              <ul class="indicator-list">
                @for (indicator of signal.indicators; track indicator) {
                  <li>{{ indicator }}</li>
                }
              </ul>
            </div>
          }
        </div>
      } @else {
        <div class="panel-empty">
          <strong>No risk signals</strong>
          <span>All repositories are within normal thresholds.</span>
        </div>
      }
    </article>

    <article class="panel">
      <div class="panel-head">
        <div>
          <p class="panel-kicker">Developers</p>
          <h2>Developer risk indicators</h2>
        </div>
        @if (developerSignals().length) {
          <span class="count-badge">{{ developerSignals().length }}</span>
        }
      </div>

      @if (developerSignals().length) {
        <div class="signal-list">
          @for (signal of developerSignals(); track signal.developerId) {
            <div class="signal-card" [class]="riskClass(signal.riskLevel)">
              <div class="signal-card-header">
                <div class="signal-identity">
                  <strong>{{ signal.displayName }}</strong>
                  <span class="signal-sub">{{ signal.email }}</span>
                </div>
                <span class="risk-badge" [class]="riskClass(signal.riskLevel)">{{ signal.riskLevel }}</span>
              </div>
              <ul class="indicator-list">
                @for (indicator of signal.indicators; track indicator) {
                  <li>{{ indicator }}</li>
                }
              </ul>
            </div>
          }
        </div>
      } @else {
        <div class="panel-empty">
          <strong>No risk signals</strong>
          <span>All developers are within normal thresholds.</span>
        </div>
      }
    </article>
  </section>
} @else if (loading()) {
  <section class="state-card">Loading risk signals…</section>
} @else if (error()) {
  <section class="state-card error">
    <p>{{ error() }}</p>
    <button type="button" class="state-button" (click)="load()">Try again</button>
  </section>
}
